import { Box, Flex, Icon, Spacer, Text } from '@chakra-ui/react';
import { IconClipboard } from 'central-icons/IconClipboard';
import { IconLayersThree } from 'central-icons/IconLayersThree';
import { IconMapPin } from 'central-icons/IconMapPin';
import type React from 'react';

import { CircleGlobeIcon, CompanyIcon } from '@revelio/assets';
import { LinkedinIcon } from '@revelio/core';

import type { EntityInfoData } from './EntityInfoPopover';

type EntityInfoContentProps = {
  nodeName: string;
  entityInfo: EntityInfoData;
  onCopy: (e: React.MouseEvent) => void;
  isShiftPressed: boolean;
};

export const EntityInfoContent = ({
  nodeName,
  entityInfo,
  onCopy,
  isShiftPressed,
}: EntityInfoContentProps) => (
  <>
    <Flex direction="row" alignItems="center">
      <Text color="white" fontSize="sm" fontWeight="semibold">
        {nodeName}
      </Text>
      <Spacer />

      <Flex gap={2} alignItems="center" justifyContent="center">
        {entityInfo.primary_linkedin_url && (
          <a
            href={entityInfo.primary_linkedin_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <Icon
              as={LinkedinIcon}
              color="white"
              boxSize="16px"
              cursor="pointer"
              aria-label="linkedin"
              opacity={0.6}
            />
          </a>
        )}
        {entityInfo.primary_website && (
          <a
            href={'https://' + entityInfo.primary_website}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <Icon
              as={CircleGlobeIcon}
              color="white"
              boxSize="16px"
              cursor="pointer"
              aria-label="website"
              opacity={0.6}
            />
          </a>
        )}
      </Flex>
    </Flex>
    {entityInfo.hasUltimateParent && (
      <Flex direction="row" alignItems="center" mt={1}>
        <Text as="span" color="white" fontSize="xs" opacity={0.6}>
          <Icon as={IconLayersThree} boxSize={2.5} mr={1} />
          Subsidiary of {entityInfo.ult_parent_name}
        </Text>
      </Flex>
    )}

    <Flex direction="row" alignItems="center" mt={1}>
      <CompanyIcon boxSize="10px" mr="4px" />
      <Text color="white" fontSize="xs" opacity={0.6}>
        {entityInfo.industry}
      </Text>
    </Flex>

    <Flex direction="row" alignItems="center">
      <Text color="white" fontSize="xs" opacity={0.6}>
        <Icon as={IconMapPin} boxSize={2.5} mr={1} />
        {entityInfo.city}
        {entityInfo.city && entityInfo.country ? ', ' : ''}
        {entityInfo.country}
      </Text>
      <Spacer />
      <Flex alignItems="center" minH="24px" transition="opacity 0.2s">
        <Box
          opacity={isShiftPressed && entityInfo.rcid ? 1 : 0}
          display="flex"
          alignItems="center"
          position="absolute"
          right="12px"
        >
          <Text color="white" fontSize="xs" opacity={0.6}>
            RCID: {entityInfo.rcid || ''}
            <Icon
              as={IconClipboard}
              color="white"
              boxSize={2.5}
              cursor="pointer"
              aria-label="Copy RCID"
              onClick={onCopy}
              ml={1}
            />
          </Text>
        </Box>
      </Flex>
    </Flex>
  </>
);
